var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-center":"","align-content-center":""}},[_c('div',[_c('div',{staticStyle:{"font-size":"5rem","line-height":"4rem"}},[_vm._v("401")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"1.3rem"}},[_vm._v("Unauthorized")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b53c278","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/Unauthorized.vue
// module id = null
// module chunks = 